import React, { SVGProps } from 'react'

export const FooterWaveAboutMoreSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    fill="none"
    preserveAspectRatio="xMinYMin meet"
    viewBox="0 0 263 32"
    {...props}
  >
    <path
      fill="#FFDED0"
      fillOpacity={0.48}
      fillRule="evenodd"
      d="M53.395 18.618c5.988-1.986 12.01-3.984 17.9-5.828C99.62 3.923 116.917.082 131.458.082c1.116-.054 2.3-.082 3.551-.082H0v32c13.056 0 33.03-6.626 53.395-13.382ZM135.01 0c14.159 0 36.953 3.613 66.472 14.76 4.072 1.538 7.806 2.967 11.262 4.29C235.863 27.9 246.574 32 263 32V0H135.011Z"
      clipRule="evenodd"
    />
  </svg>
)
